export default {
  data () {
    return {}
  },
  methods: {
  },
  computed: {
    hasActiveAnalytics: function () {
      const GTMCode = this.$store.getters.getGTMCode
      return !!(GTMCode && window.dataLayer && GTMCode !== 'N')
    }
  }
}
